import { Box, HStack } from '@terra/ui-styled-system';
import { TechnologyIcon } from '@terra/ui-design-system';
import { type CodeGraphWithRelations } from '@terra/shared-schemas-git';

interface CustomNodeTechnologiesProps {
  technologies: NonNullable<CodeGraphWithRelations['technologies']>;
}

const TECHNOLOGY_LIMIT_VISIBLE = 3;
const TECHNOLOGY_LIMIT_REMAINING = 2;

export function CustomNodeTechnologies({
  technologies,
}: CustomNodeTechnologiesProps) {
  const maxVisible =
    technologies.length <= TECHNOLOGY_LIMIT_VISIBLE
      ? TECHNOLOGY_LIMIT_VISIBLE
      : TECHNOLOGY_LIMIT_REMAINING;
  const visibleTechnologies = technologies.slice(0, maxVisible);
  const remainingCount = technologies.length - maxVisible;

  return (
    <Box>
      <HStack gap={0} alignItems="center" justifyContent="center">
        {visibleTechnologies.map((technology, index) => (
          <Box
            w="8"
            h="8"
            borderRadius="full"
            bg="gray.3"
            display="flex"
            alignItems="center"
            justifyContent="center"
            ml={-1}
            mr={-1}
            color="gray.12"
            fontSize="xs"
            fontWeight="semibold"
            overflow="hidden"
            key={`${technology.name}-${index}`}
          >
            <TechnologyIcon
              name={technology.name}
              style={{ width: 24, height: 24 }}
              showInitials
            />
          </Box>
        ))}
        {remainingCount > 0 && (
          <Box
            h="8"
            minW="8"
            borderRadius="full"
            bg="neutral.muted"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="xs"
            color="fg.default"
            pl={0.5}
            pr={0.5}
            ml={-1}
            mr={-1}
          >
            +{remainingCount}
          </Box>
        )}
      </HStack>
    </Box>
  );
}
